import { render, staticRenderFns } from "./truck_type_edit.vue?vue&type=template&id=33a89758&scoped=true&"
import script from "./truck_type_edit.vue?vue&type=script&lang=js&"
export * from "./truck_type_edit.vue?vue&type=script&lang=js&"
import style0 from "./truck_type_edit.vue?vue&type=style&index=0&id=33a89758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a89758",
  null
  
)

export default component.exports